import axiosInstance from '../../instance/AxiosInstance';
const loginApi = async (credentials) => {
  try {
    const response = await axiosInstance.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Login failed');
  }
};
const forgotPasswordApi = async (email) => {
  try {
    const response = await axiosInstance.post('/auth/otpsend', { email });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Failed to send reset link'
    );
  }
};
const verifyEmailApi = async ({ email, verification_code }) => {
  try {
    const response = await axiosInstance.post('/auth/verifyotp', {
      email,
      verification_code,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
export { loginApi, forgotPasswordApi, verifyEmailApi };
